// @ts-nocheck
import $ from 'jquery';
import hoverintent from 'hoverintent';
import { initiateFadeInUpAnimation, removeFadeInUpAnimation } from './fadeInUpAnimation';

export default class Menu {
  constructor(theme, element) {
    const self = this;
    this.theme = theme;
    this.element = element;
    this.$element = $(element);

    this.$nav = $('#AccessibleNav');
    this.$allLinks = this.$nav.find('a');
    this.$topLevel = this.$nav.children('li').find('a');
    this.$parents = this.$nav.find('.site-nav--has-dropdown');
    this.$parentsNoDropdown = this.$nav.find('li:not(.site-nav--has-dropdown)');
    this.$subMenus = this.$nav.find('.site-nav__dropdown');
    this.$subMenuLinks = this.$subMenus.find('a');
    this.activeClass = 'nav-hover';
    this.$sectionId = this.$element.attr('data-wetheme-section-id');
    this.$megaMenu = document.querySelector('.mega-menu-block');
    this.$megaMenuChildren = document.querySelectorAll('.mega-menu-block .dropdown-submenu');

    if (window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', (e) => {
        if (e.detail.sectionId == this.$sectionId) {
          initiateFadeInUpAnimation(this.$megaMenuChildren);
          this.$element.addClass('section-selected');
        } else {
          removeFadeInUpAnimation(this.$megaMenuChildren);
          this.$element.removeClass('section-selected');
        }
      });

      document.addEventListener('shopify:section:deselect', (e) => {
        if (e.detail.sectionId == this.$sectionId) {
          removeFadeInUpAnimation(this.$megaMenuChildren);
          this.$element.removeClass('section-selected');
        }
      });
    }

    this.$parentsNoDropdown.on('mouseover', function() {
      $('li.mega-menu').removeClass('nav-hover');
    });

    this.$parents.on(
      'mouseover touchstart focusin',
      function(evt) {
        var ret = true;
        var $el = $(this);

        if (!$el.hasClass(self.activeClass)) {
          evt.preventDefault();
          self.hideDropdown($el.siblings());
          ret = false;
        }

        self.showDropdown($el);
        return ret;
      }
    );

    this.$parents.each(
      (i, el) => {
        hoverintent(
          el,
          function(evt) {
            $('.' + self.activeClass).each(function (el) {
              var $active = $(this);
              if ($active.has(evt.target).length === 0) {
                $active.removeClass(self.activeClass);
              }
            });
          },
          function() {
            // This is triggered when hovering over sub-menus /
            // child elements, so avoid using self.hideDropdown()
            // here.
          }
        );

        if(!$(el).hasClass('mega-menu') && $(el).parent().hasClass('site-nav')) {
          $(el).on('mouseleave', () => {
            self.hideDropdown();
          });
        }
      }
    );

    // Handle focus for submenus.
    this.$parents.each((i, el) => {
      $(el).on('focusin', function(elem) {
        self.showDropdown($(el));
      });
    });

    // Mouseout / blur.
    $('.site-header').on('mouseleave', () => {
      self.hideDropdown();
    });

    $('.site-nav__dropdown').on('mouseleave focusout', (evt) => {
      self.hideDropdown($(this));
    });

    $(this.$megaMenu).on('mouseleave', () => {
      self.hideDropdown();
    });

    this.$subMenuLinks.on(
      'touchstart',
      function(evt) {
        // Prevent touchstart on body from firing instead of link
        evt.stopImmediatePropagation();
      }
    );

    this.$allLinks.on('focusin', function(evt) {
      let $el = $(this).parent();
      self.closeSiblings($el, evt);
    });

    $('.site-header').find('a, button, select').on('focusin', function() {
      // If this is not a menu (e.g. icon, logo), close all menus.
      let thisElem = this;
      let closeAllMenus = true;

      self.$allLinks.each(function() {
        if($(this).is(thisElem)) {
          closeAllMenus = false;
        }
      });

      if(closeAllMenus) {
        self.$parents.each(function() {
          self.hideDropdown($(this));
        });
      }
    });
  }

  closeSiblings = ($el, evt) => {
    if (!$el.hasClass(this.activeClass)) {
      evt.preventDefault();
      this.hideDropdown($el.siblings());
    }
  }

  showDropdown = ($el) => {
    $el.addClass(this.activeClass);
    const self2 = this;

    // Initiate mega menu animation
    
    initiateFadeInUpAnimation(this.$megaMenuChildren);

    if ($('.site-header').hasClass('overlay-header')) {
      $('.sticky-header').addClass('sticked sticky-header-open');
    }

    // Remove iOS workaround because it breaks menu z-index
    $('.sticky-header').removeClass('sticky-header-transformed');

    // Select if the submenu should appear left or right of the menu
    var $child = $el.parent().find('.site-nav__subdropdown');
    var childWidth = Math.max.apply(null, $child.map(function () { return $(this).width() }).get());
    var right = $el.offset().left + $el.outerWidth() + childWidth;
    if (right > $('body').width()) {
      $child.css({
        right: '100%',
        left: 'auto',
        top: '-30px'
      });
    } else {
      $child.css({
        left: '100%',
        right: 'auto',
        top: '-30px'
      });
    }

    setTimeout(function() {
      $(document.body).on(
        'touchstart',
        (evt) => {
          if (
            $(evt.target).closest('.site-nav__link,.dropdown-submenu').length === 0
          ) {
            // Hide dropdown if the touchstart was not on nav link
            self2.hideDropdown($el);
          }
        }
      );
    }, 250);
  }

  hideDropdown = ($el) => {
    if ($el !== undefined) $el.removeClass(this.activeClass);
    else $('.site-nav--has-dropdown').removeClass(this.activeClass);
    $(document.body).off('touchstart');

    // Remove mega menu animation 
    if (!this.$element.hasClass('section-selected')) {
      removeFadeInUpAnimation(this.$megaMenuChildren);
    }

    if ($('.site-header').hasClass('overlay-header')) {
      $('.sticky-header').removeClass('sticky-header-open');
    }

    // Reenable iOS workaround
    if ($('.nav-hover').length === 0) {
      $('.sticky-header').addClass('sticky-header-transformed');
    }
  }
}
